import { GetFaqItemQuery, useGetFaqItemQuery } from '@/api/sanity/generated';
import { sanityLanguage } from '@/constants/language';
import type { MDXRemoteSerializeResult } from 'next-mdx-remote';
import { serialize } from 'next-mdx-remote/serialize';

export type Question = NonNullable<NonNullable<GetFaqItemQuery['allFaqQuestion']>>[number] & {
	descriptionMarkdown?: MDXRemoteSerializeResult;
};

export async function getActiveQuestionDetail(slug: string): Promise<Question | null> {
	const fetchQuestion = useGetFaqItemQuery.fetcher({
		slug,
		i18nLang: sanityLanguage,
	});
	const question = await fetchQuestion();

	if (!question.allFaqQuestion?.[0]) {
		return null;
	}

	const activeQuestion = {
		...question.allFaqQuestion[0],
		descriptionMarkdown: await serialize(question.allFaqQuestion[0].description || ''),
	} as Question;

	return activeQuestion;
}
